/* eslint-disable */

var slider = $(".js-testimonial-slider");
prev_arrow = $(".js-testimonial-prev-arrow");
next_arrow = $(".js-testimonial-next-arrow");
slider.slick({
    slidesToShow: 2,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow: prev_arrow,
    nextArrow: next_arrow,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
});



// WEBPACK FOOTER //
// ./scripts/partials/testimonial-slider.js